import script from "./detailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./detailPage.vue?vue&type=script&setup=true&lang=js"

import "./detailPage.vue?vue&type=style&index=0&id=6dfecbde&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dfecbde"]])

export default __exports__